import { cn } from '@bem-react/classname';

export const cnModal = cn('Modal');
